<confirm>
  <div class="com-form">
    <form>
      <p class="ext">
        下記の内容で誤りがないかをご確認ください。
      </p>
      <div class="com-form__item ">
        <p class="com-form__item__caption"><span>名前</span></p>
        <div class="com-form__item__content">
          <div class="com-form__item__input input-text">
            {coreData["name"]}
          </div>
        </div>
      </div>

      <div class="com-form__item">
        <p class="com-form__item__caption"><span>メールアドレス</span></p>
        <div class="com-form__item__content">
          <div class="com-form__item__input input-text">
            {coreData["email"]}
          </div>
        </div>
      </div>

      <div class="com-form__item">
        <p class="com-form__item__caption"><span>お問い合わせ内容</span></p>
        <div class="com-form__item__content">
          <div class="com-form__item__input input-textarea">
            <pre>{coreData["content"]}</pre>
          </div>
        </div>
      </div>


      <div class="com-form__submit">
        <a class="com-btn-back-01" onclick="{back}" if={!isLoading}><span>戻る</span></a>
        <button typte="button" class="com-btn-01" onclick="{execute}" if={!isLoading}><span>お問合せをする</span></button>
      </div>
    </form>
  </div>

  <script>
    import di from 'dependeny-injection'
    import Validator from '@croco/validator'

    export default {
      isLoading: false,
      coreData: {},
      onMounted() {
        this.coreData = di.inquiry.coreData.toData();
        this.update();
      },
      back(e) {
        e.preventDefault();
        di.inquiry.tag('inquiry');
      },
      execute(e) {
        e.preventDefault();
        di.inquiry.changeLoaderState(true, this, 'isLoading');
        di.inquiry.api('', di.inquiry.coreData.toData())
        .then((data) => {
            di.inquiry.changeLoaderState(false, this, 'isLoading');
            if (data.status) {
                di.inquiry.tag('execute');
                di.inquiry.unlockUnload();
                di.inquiry.coreData = new Validator({
                    name: '',
                    email: '',
                    content: '',
                    agree: ''
                });
            }
        });

      }
    }
  </script>
</confirm>